






















import Vue from 'vue';
import { CaseType } from '@/plugins/digitalVerification';
import { GetValue } from '@/plugins/utilities';
import { EventBus } from '@/plugins/eventBus';
export default Vue.extend({
  name: 'IdvChoices',
  data: () => ({
      cases: CaseType,
      selected: {
        name: 'Jackson',
        fName: 'Jackson',
        lName: 'Smith',
        ssn: '666010030',
        address: {
            state: 'GA',
            region: 'Atlanta',
            postalCode: '30326',
            street: '1000 Juniper',
        },
      },
      items: [{
        name: 'Jackson',
        fName: 'Jackson',
        lName: 'Smith',
        ssn: '666010030',
        address: {
            state: 'GA',
            region: 'Atlanta',
            postalCode: '30326',
            street: '1000 Juniper',
        },
      },
      {
          name: 'Shaw',
          fName: 'David',
          lName: 'Shaw',
          ssn: '666010031',
          address: {
              state: 'GA',
              region: 'Atlanta',
              postalCode: '30326',
              street: '400 Dodson',
          },
      },
      {
          name: 'Spencer',
          fName: 'Chris',
          lName: 'Spencer',
          ssn: '666010029',
          address: {
              state: 'GA',
              region: 'Atlanta',
              postalCode: '30326',
              street: '300 Chamblee',
          },
      }],
  }),
  methods: {
      changed(obj: object) {
        EventBus.$emit('trustev', obj);
        const fName = document.querySelector('#FirstName');
        const lName = document.querySelector('#LastName');
        const ssn = document.querySelector('#SSN');
        if (fName) {
          (fName as any).value = (obj as any).fName;
          (fName as any).dispatchEvent(new Event('input'));
        }
        if (lName) {
          (lName as any).value = (obj as any).lName;
          (lName as any).dispatchEvent(new Event('input'));
        }
        if (ssn) {
          (ssn as any).value = (obj as any).ssn;
          (ssn as any).dispatchEvent(new Event('input'));
        }
      },
      cased(str: string) {
        EventBus.$emit('trustev_case', str);
      },
  },
});
